import React, { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Signin from "./pages/Signin";
import Account from "./pages/Account";
import AdminPage from "./pages/AdminPage";
import Teacher from "./pages/Teacher";
import Money from "./pages/Money";
import UpcomingCourses from "./pages/UpcomingCourses";
import MesCours from "./pages/MesCours";
import Professeurs from "./pages/Professeurs";
import ProtectedRoute from "./pages/ProtectedRoute";
import SplashScreen from "./pages/SplashScreen";
import { MentionsLegales, CGV, Confidentialite } from "./pages/Legal";
import TermsGate from "./pages/Components/TermsGate";
import { AuthContextProvider } from "./context/AuthContext";
import { LanguageProvider } from "./i18n/LanguageContext";

// L'animation d'intro ne s'affiche qu'une fois par session de navigation
const splashAlreadySeen = () => {
  try {
    return sessionStorage.getItem("ts_splash_seen") === "1";
  } catch {
    return false;
  }
};

function App() {
  const [splashDone, setSplashDone] = useState(splashAlreadySeen);

  const handleSplashDone = () => {
    try {
      sessionStorage.setItem("ts_splash_seen", "1");
    } catch {
      /* stockage indisponible : on ignore */
    }
    setSplashDone(true);
  };

  if (!splashDone) {
    return (
      <LanguageProvider>
        <SplashScreen onDone={handleSplashDone} />
      </LanguageProvider>
    );
  }

  return (
    <LanguageProvider>
    <AuthContextProvider>
      <div className="App">
        <BrowserRouter>
          <TermsGate />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/signin" element={<Signin />} />
            <Route path="/cours_a_venir" element={<UpcomingCourses />} />
            <Route path="/professeurs" element={<Professeurs />} />
            <Route path="/Teacher/:teacherId" element={<Teacher />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/cgv" element={<CGV />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mes_cours"
              element={
                <ProtectedRoute>
                  <MesCours />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portefeuille"
              element={
                <ProtectedRoute>
                  <Money />
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminpage"
              element={
                <ProtectedRoute role={0}>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthContextProvider>
    </LanguageProvider>
  );
}

export default App;
